import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainRoutes } from '../../guards/guard.models';
import { SessionGuard } from '../../guards/session/session.guard';
import { MainRequestsListComponent } from '../../shared/main-requests-list/main-requests-list.component';
import { NewSupplementaryParcelPurchaseRequestComponent } from './new-supplementary-parcel-purchase-request/new-supplementary-parcel-purchase-request.component';
import { SupplementaryParcelPurchasePortalComponent } from './supplementary-parcel-purchase-portal.component';

const supplementaryParcelPurchasePortalRoutes: Routes = [
  {
    path: MainRoutes.SupplementaryParcelPurchase,
    component: SupplementaryParcelPurchasePortalComponent,
    canActivate: [SessionGuard],
    children: [
      {
        path: '',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
      {
        path: 'new-request',
        component: NewSupplementaryParcelPurchaseRequestComponent,
      },
      {
        path: 'requests-list',
        component: MainRequestsListComponent,
      },
      {
        path: '**',
        redirectTo: 'new-request',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(supplementaryParcelPurchasePortalRoutes)],
  providers: [],
  exports: [RouterModule],
})
export class SupplementaryParcelPurchasePortalRoutingModule {}
